import React from 'react';

import Logo from '../img/logo2.jpg'

function NavigationBar() {
  return (
    <>
      <div>
     <img className='logo-img' src={Logo}/>
     </div>
    </>
  );
}

export default NavigationBar;
